<template>
  <div class="page">
    <h1>Персонал</h1>
    <Card>
      <form>
        <div class="vm-form-header">
          Доктор:
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Очень длинная надпись бла бла бла:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input invalid placeholder="Ввериде ваши данные..." />
              <Error>
                Это поле обязательнное
              </Error>
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Очень:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input placeholder="Ввериде ваши данные..." />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Очень длинная надпись:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Input v-model="model" disabled />
            </FormField>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label-wrap">
            <label class="vm-label">Очень длинная надпись бла бла бла:</label>
          </div>
          <div class="vm-formfield-wrap">
            <FormField>
              <Textarea v-model="model" />
            </FormField>
          </div>
        </div>
      </form>
    </Card>
  </div>
</template>

<script>
import Input from '@app/components/uikit/Input';
import Textarea from '@app/components/uikit/Textarea';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';
import Card from '@app/components/uikit/Card';


export default {
  components: {
    Input,
    Textarea,
    FormField,
    Error,
    Card
  },
  data: () => ({
    model: 'dadasdasdasdasda'
  })
};
</script>

<style scoped>
form {
  padding: 12px 24px;
}
.vm-label {
  color: #B1B1B1;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 36px;
}
.vm-form-group {
  display: flex;
}
.vm-form-header {
  text-align: right;
  font-weight: 500;
  color: #8C30DA;
  text-transform: uppercase;
  font-size: 20px;
  margin-bottom: 24px;
}
.vm-form-header,
.vm-label-wrap {
  width: 240px;
}
.vm-label-wrap {
  text-align: right;
  margin-right: 12px;
  padding-bottom: 24px;
}
.vm-formfield-wrap {
  flex: auto;
  align-self: center;
}
@media (max-width: 700px) {
  .vm-label {
    justify-content: flex-start;
    line-height: 1;
    min-height: auto;
    margin-bottom: 6px;
  }
  .vm-form-group {
    flex-direction: column;
  }
  .vm-label-wrap {
    padding: 0;
    margin: 0;
  }
  .vm-formfield-wrap,
  .vm-label-wrap {
    width: 100%;
  }
}
</style>


